import { GraphQLClient } from 'graphql-request';

// API endpoints
const STOREFRONT_API_URL = `https://${import.meta.env.VITE_SHOPIFY_STORE_DOMAIN}/api/${import.meta.env.VITE_SHOPIFY_API_VERSION}/graphql.json`;
const CUSTOMER_API_URL = `https://${import.meta.env.VITE_SHOPIFY_STORE_DOMAIN}/api/${import.meta.env.VITE_SHOPIFY_API_VERSION}/graphql.json`;

// Create three different clients for different contexts
export const storefrontClient = new GraphQLClient(STOREFRONT_API_URL, {
  headers: {
    'X-Shopify-Storefront-Access-Token': import.meta.env.VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
    'Content-Type': 'application/json',
  },
});

export const adminClient = new GraphQLClient(STOREFRONT_API_URL, {
  headers: {
    'X-Shopify-Access-Token': import.meta.env.VITE_SHOPIFY_ADMIN_ACCESS_TOKEN,
    'Content-Type': 'application/json',
  },
});

export const customerClient = new GraphQLClient(CUSTOMER_API_URL, {
  headers: {
    'X-Shopify-Storefront-Access-Token': import.meta.env.VITE_SHOPIFY_X_STOREFRONT_ACCESS_TOKEN,
    'Content-Type': 'application/json',
  },
}); 